export const theme = {
  primaryColor: `#232326`,
  secondaryColor: `#404046`,
  accentColor: `#588FE6`,
  grayScaleColor: `rgba(255, 255, 255, 0.7)`,
}
